import { get } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "IntegrationStatus";

export const getImportClassroomAttendanceStatus = async () => {
   
    return await get(baseRoute, "clasroom_attendance");
};

const integrationStatusService = {
    getImportClassroomAttendanceStatus,
}

export default integrationStatusService;